import { environment as devEnv } from './environment.dev';
import { base } from './environment.base';

const server = base.server;

const datastore = {
    domain: server.domain + '/warehouse',
    port: '',
    protocol: 'https://',
};

//blank = same-origin sockets (io('/namespace') resolves against the current site),
//so prod builds also work on dev/staging hosts - same reasoning as nihulDomain below
const sameOriginSockets = {
    domain: '',
    port: '',
    protocol: '',
};

export const environment = {
    production: true,
    app: server,
    api: server,
    auth: server,
    proxySource: server,
    assets: server,
    template: server,
    warehouse: datastore,
    sockets: sameOriginSockets,
    pic: base.pic,
    video: base.video,
    chatbot: server,
    googleApiKey: 'AIzaSyDMnLemFHIt-vc4GDUxs5NaMuWwNo3IlBI',
    recaptchaV2SiteKey: '6LescXMUAAAAAOBdCy7elPzw4VSxjuGOhzNdZOMH',
    //Google sign-in (the login dialog) - the public OAuth client id, same value web.config holds
    googleAuthClientId: '350919494475-2b99jacte3tnq1pn8qb70v5abdglf9vt.apps.googleusercontent.com',
    //relative on purpose (2026-07-15): nihul calls stay same-origin, so prod builds also
    //work on dev/staging hosts. The english site may hit cross-origin walls (the revealed
    //cms links carry //serverHEB there) - accepted: english editing falls back to the
    //hebrew nihul if it misbehaves
    nihulDomain: '',
};
